import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import { DOCUMENTSTORE_SERVICE_URL } from "../../constants/ServiceUrls";

export const getClientReports = (applicationType) => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/Reports/GetClientReports?applicationType=${applicationType}`
  );
};

export const loadReport = (params) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Reports/LoadReport`,
    params
  );
};

export const CSVDownloadReport = (params) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Reports/CSVDownloadReport`,
    params,
    { responseType: "blob" }
  );
};

export default {
  getClientReports,
  loadReport,
  CSVDownloadReport,
};
